import 'view/css/report.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';

import Protected from 'component/Protected';
import LocationSelect from 'component/dropdown/LocationSelect';

import moment from 'moment';
import LocationReportViewContent from './LocationReportViewContent';

//-------------------------------------

const getIxList = N => {
  let list = [];
  let cur = moment().startOf('month');
  for (let i = 0; i < N; i++)
  {
    list.push( parseInt(moment(cur).format('yyyyMM'), 10) );
    cur = moment(cur).add(-1, 'month');
  }
  list.reverse();
  return list;
};

function createOpt(title) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yLeft: {
        position: 'left',
      },
      yRight: {
        position: 'right',
        grid: { drawOnChartArea: false, },
      },
    },
    options: {
      indexAxis: 'x',
    },
    plugins: {
      title: { display: true, text: title, fontSize: 20 },
    }
  };
}

const optrpt = createOpt('過去十二個月各區車輛服務數量統計');

const C_MONTH_COUNT = 6;

const cache = { };

//-------------------------------------
const LocationReportView = (props) =>
{
  let [exporting,   setExporting] = useState(false);

  let [sel_display, setDisplay  ] = useState('table');
  let [sel_company, setCompany  ] = useState('');
  let [sel_dis,     setDistrict ] = useState('');
  let [sel_loc,     setLocation ] = useState('');
  let [sel_mgt,     setMgtDist  ] = useState('');
  let [sel_fleet,   setFleet    ] = useState('');
  let [sel_month,   setMonth    ] = useState(C_MONTH_COUNT - 1);

  let [data,        setData     ] = useState(null);
  let [defChartData, setDefChartData ] = useState(null);

  let [IxMonths,    setIXMonths ] = useState(getIxList(C_MONTH_COUNT));
  let [DMapMgtDist, setMapMgt   ] = useState([]);
  let [DMapFleet,   setMapFleet ] = useState([]);

  // ---------------------------
  const exportXls_3dist = () =>
  {
    setExporting(true);

    let _ixm = String(IxMonths[sel_month]);
    let filter = {
      from_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD'),
      to_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD')
    };

    const ix_today = moment().format('YYYYMMDD_HHmm');
    API.export3DistLocationReport(filter).then(resp => {
      Util.download(resp, `各區新車報表_${ix_today}.zip`);
      setExporting(false);
    });
  } // export xlsx

  const exportXls_7dist = () =>
  {
    setExporting(true);

    let _ixm = String(IxMonths[sel_month]);
    let filter = {
      from_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD'),
      to_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD')
    };

    const ix_today = moment().format('YYYYMMDD_HHmm');
    API.export7DistLocationReport(filter).then(resp => {
      Util.download(resp, `各屋苑及車隊新車重開及終止服務報表_${ix_today}.zip`);
      setExporting(false);
    });
  } // export xlsx


  const getData = () =>
  {
    let _ixm = String(IxMonths[sel_month]);
    let filter = {
      from_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD'),
      to_dtm: moment(_ixm, 'YYYYMM').format('YYYY-MM-DD')
    };

    if (cache[_ixm]) {

      let { chartData, data, mgt, flt } = cache[_ixm];
      setDefChartData(chartData);
      setData(data);
      setMapMgt(mgt);
      setMapFleet(flt);

    } else {
      API.getReportLocation(filter).then(chartData => {

        let data = chartData.datasets[0].data;
        delete chartData.datasets[0].data;
        setDefChartData(chartData);
        setData(data);

        let [ixs, mgt, flt] = data.reduce((r,x) => {
          r[0].add(x.ix);
          r[1].add(x.mgt_dis);
          r[2].add(x.cd_fleet);
          return r;
        }, [new Set(), new Set(), new Set()]).map(a => Array.from(a).sort());

        //setIXMonths(ixs);
        //setMonth(ixs.length - 1);
        setMapMgt(mgt);
        setMapFleet(flt);

        cache[_ixm] = { chartData, data, mgt, flt };

      }); // API call
    }

  };

  // init ----
  useEffect(() => {
    getData();
  }, [sel_month]);

  return (<>
    <h1>報表 - 屋苑服務統計</h1>
    { !!data && <>
      <div className="search-bar action-panel">
        <div className="row">
          {
          /*
          <label className="field-row">
            <strong>顯示</strong>
            <select value={sel_display} onChange={e=>setDisplay(e.target.value)}>
              <option value="graph">圖表</option>
              <option value="table">表格</option>
            </select>
          </label>
          */
          }
          { sel_display == 'table' &&
            <label className="field-row">
              <strong>月份</strong>
              <select value={sel_month} onChange={e=>setMonth(parseInt(e.target.value,10))}>
                { IxMonths.map((ix, i) =>
                  <option key={ix} value={i}>{ moment(ix, 'YYYYMM').format('YYYY年 MM月')}</option>
                )}
              </select>
            </label>
          }
          <label className="field-row">
            <strong>公司</strong>
            <select value={sel_company} onChange={e=>setCompany(e.target.value)}>
              <option value="">全部</option>
              { Data.company.map(com =>
                <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
              )}
            </select>
          </label>
          <label className="field-row">
            <strong>屋苑</strong>
            <LocationSelect all noLabel district={sel_dis} location={sel_loc}
              onUpdate={(d,l) => { setDistrict(d); setLocation(l); }}
              />
          </label>
          <label className="field-row">
            <strong>管轄區</strong>
            <select value={sel_mgt} onChange={e=>setMgtDist(e.target.value)}>
              <option value="">全部</option>
              {DMapMgtDist.map(m =>
                <option key={m} value={m}>{m}</option>
              )}
            </select>
          </label>
          <label className="field-row">
            <strong>車隊</strong>
            <select value={sel_fleet} onChange={e=>setFleet(e.target.value)}>
              <option value="">全部</option>
              {DMapFleet.map(f =>
                <option key={f} value={f}>{f}</option>
              )}
            </select>
          </label>
        </div>
        <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
          <div className="button-group">
            <button className="btn dark-green btn-export" onClick={exportXls_3dist} disabled={exporting}>
              <FontAwesomeIcon icon={faFileExcel} />
              <span>三區報表</span>
            </button>
            <button className="btn dark-green btn-export" onClick={exportXls_7dist} disabled={exporting}>
              <FontAwesomeIcon icon={faFileExcel} />
              <span>七區報表</span>
            </button>
          </div>
        </Protected>
      </div>
    </>}
    <div className="chart-container">
      <LocationReportViewContent data={data} defChartData={defChartData}
        sel_display={sel_display} sel_company={sel_company}
        sel_dis={sel_dis} sel_loc={sel_loc} sel_mgt={sel_mgt} sel_fleet={sel_fleet}
        sel_month={sel_month} IxMonths={IxMonths}
      />
    </div>
  </>);

}

export default LocationReportView;